import { WorkspaceUserWithAttributes, AgentsStatsData } from 'enablex/sdk'

import api from '~/app/api'
import { AppThunk } from '~/app/rootReducer'

const FETCH_USERS_REQUESTED = 'user/FETCH_USERS_REQUESTED'
const FETCH_USERS_RECEIVED = 'user/FETCH_USERS_RECEIVED'
const AVAILABLE_USERS_RECEIVED = 'user/AVAILABLE_USERS_RECEIVED'
const FETCH_AGENTS_STATS_REQUESTED = 'user/FETCH_AGENTS_ANALYTICS_REQUESTED'
const FETCH_AGENTS_STATS_RECEIVED = 'user/FETCH_AGENTS_ANALYTICS_RECEIVED'
const FETCH_BRANDING_REQUESTED = 'user/FETCH_BRANDING_REQUESTED'
const FETCH_BRANDING_RECEIVED = 'user/FETCH_BRANDING_RECEIVED'
const AGENTS_ANALYTICS_OPEN = 'user/AGENTS_ANALYTICS_OPEN'
const AGENTS_ANALYTICS_CLOSE = 'user/AGENTS_ANALYTICS_CLOSE'

interface CollaboratorsState {
  loading: boolean
  agentStatsLoading: boolean
  isAgentAnalyticsOpen: boolean
  brandingLoading: boolean
  users?: WorkspaceUserWithAttributes[]
  availableUsers?: WorkspaceUserWithAttributes[]
  agentsStatsData?: AgentsStatsData[]
  branding?: any
}

const initialState: CollaboratorsState = {
  users: undefined,
  loading: false,
  agentStatsLoading: false,
  isAgentAnalyticsOpen: false,
  brandingLoading: false,
  branding: undefined
}

export default (state = initialState, action): CollaboratorsState => {
  switch (action.type) {
    case FETCH_USERS_REQUESTED:
      return {
        ...state,
        loading: true
      }

    case FETCH_USERS_RECEIVED:
      return {
        ...state,
        loading: false,
        users: action.users
      }

    case AVAILABLE_USERS_RECEIVED:
      return {
        ...state,
        availableUsers: action.availableUsers
      }

    case FETCH_AGENTS_STATS_REQUESTED:
      return {
        ...state,
        agentStatsLoading: true
      }

    case FETCH_AGENTS_STATS_RECEIVED:
      return {
        ...state,
        agentStatsLoading: false,
        agentsStatsData: action.agentsStatsData
      }

    case AGENTS_ANALYTICS_OPEN:
      return {
        ...state,
        isAgentAnalyticsOpen: true,
      }

    case AGENTS_ANALYTICS_CLOSE:
      return {
        ...state,
        isAgentAnalyticsOpen: false,
      }

    case FETCH_BRANDING_REQUESTED:
      return {
        ...state,
        brandingLoading: true
      }

    case FETCH_BRANDING_RECEIVED:
      return {
        ...state,
        brandingLoading: false,
        branding: action.branding
      }

    default:
      return state
  }
}

export const toggleAnalyticsWindow = (): AppThunk => {
  return async (dispatch, getState) => {
    const { collaborators: state } = getState()
    if(state.isAgentAnalyticsOpen) {
      dispatch({ type: AGENTS_ANALYTICS_CLOSE })
    } else {
      dispatch({ type: AGENTS_ANALYTICS_OPEN })
    }
  }
}

export const fetchUsers = (filterRoles?: string): AppThunk => {
  return async (dispatch, getState) => {
    const { collaborators: state } = getState()

    if (state.loading) {
      return
    }

    dispatch({ type: FETCH_USERS_REQUESTED })
    const query = (filterRoles && `?roles=${filterRoles}`) || ''
    console.log('query', query)
    const { data: users } = await api.getSecured().get(`/admin/workspace/collaborators${query}`)
    dispatch({ type: FETCH_USERS_RECEIVED, users: users.payload })
  }
}

export const fetchBranding = (workspaceId: string): AppThunk => {
  return async (dispatch, getState) => {
    const { collaborators: state } = getState()

    if (state.brandingLoading) {
      return
    }
    const root = document.documentElement
    let themeColor = '#1d6c90'
    dispatch({ type: FETCH_BRANDING_REQUESTED })

    // set branding for workspace
    try {
      const response = await api.getSecured().get(`/admin/user/workspaces/${workspaceId}`)
      if (response.data && response.data.branding) {
        //for super admin
        const branding = {...response.data.branding, parentDomain: response.data.parentDomain}
        localStorage.setItem('enx/branding', JSON.stringify(branding))
        themeColor = branding.themeColor
        dispatch({ type: FETCH_BRANDING_RECEIVED, branding: {...branding, workspaceId} })
      } else if (response.data[0] && response.data[0].branding) {
        //for other users
        const branding = {...response.data[0].branding, parentDomain: response.data.parentDomain}
        localStorage.setItem('enx/branding', JSON.stringify(branding))
        themeColor = branding.themeColor
        dispatch({ type: FETCH_BRANDING_RECEIVED, branding: {...branding, workspaceId} })
      } else {
        dispatch({ type: FETCH_BRANDING_RECEIVED, branding: {
          themeColor: '#1d6c90',
          subDomain: '',
          logoURL: '',
          faviconURL: '',
          pageTitle: '',
          workspaceId
        }})
        localStorage.removeItem('enx/branding')
      }
      root.style.setProperty('--theme-color', themeColor)
    } catch(err) {
      console.error(err)
      root.style.setProperty('--theme-color', themeColor)
    }
  }
}

export const fetchAgentsStatsData = (workSpaceId: string): AppThunk => {
  return async (dispatch, getState) => {
    const { collaborators: state } = getState()

    if (state.agentStatsLoading) {
      return
    }

    dispatch({ type: FETCH_AGENTS_STATS_REQUESTED })
    const { data: agentsStatsData } = await api.getSecured().get(`/admin/workspace/collaborators/agentsStatsData/${workSpaceId}`)
    dispatch({ type: FETCH_AGENTS_STATS_RECEIVED, agentsStatsData: agentsStatsData.payload })
  }
}

export const fetchAvailableUsers = (filterRoles?: string): AppThunk => {
  const query = (filterRoles && `?roles=${filterRoles}`) || ''
  return async dispatch => {
    const { data } = await api.getSecured().get(`/admin/workspace/collaborators/listAvailableUsers${query}`)
    dispatch({ type: AVAILABLE_USERS_RECEIVED, availableUsers: data.payload })
  }
}
